module.exports = __webpack_public_path__ + "static/media/logo.31d3f8a5.png";